// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"test_notice-module_wrapper_ab804","header":"test_notice-module_header_b5e92","paragraph":"test_notice-module_paragraph_aed56","link":"test_notice-module_link_b66d8"};